{
  "labels": {
    "izberi": "Seleziona lingua",
    "buttons": {
      "odpriJezik": "Imposta lingua",
      "potrdiJezik": "Modifica",
      "generiranje": "Cambiamento"
    }
  },
  "obvestila": {
    "vprasanjeMenjave": "Stai per cambiare la lingua dell'interfaccia. Vuoi procedere?",
    "uspesno": "Lingua dell'interfaccia utente modificata con successo",
	"napakaPosodabljanja": "Errore nell'aggiornamento dei dati"
  }
}